import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ControlsModule } from 'src/app/controls/controls.module';
import { ExamService } from 'src/app/core/exam.service';

@Component({
  selector: 'app-create-test',
  templateUrl: './create-test.component.html',
  styleUrls: ['./create-test.component.scss'],
  imports: [
    CommonModule,
    ControlsModule,
    TranslateModule,
    FormsModule
  ]
})
export class CreateTestComponent {

  form!: FormGroup;
  isLoading: boolean = false;

  @Input() courseId!: number;
  @Output() processFinished: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private fb: FormBuilder,
    private examService: ExamService
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]]
    });
  }

  saveTest() {
    this.form.markAllAsTouched();
    if (!this.form.valid) {
      return;
    }
    this.isLoading = true;
    this.examService.createExamTemplate({ name: this.form.value.name, courseId: this.courseId }).subscribe((result) => {
      this.isLoading = false;
      this.processFinished.emit();
    });
  }
  
  getControl(control: string) {
    return this.form!.get(control) as FormControl;
  }
}
